const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/branding.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// BrandingLayout
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/branding")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Branding",
      description: "Page title"
    })
  }
});